<template lang="html">
    <div class="service">
        <div class="banner-img">
            <!-- <img width="100%" src="https://static.qyjmed.com/webSite/productService/service/service-bg.png" alt=""> -->
        </div>
        <div class="order">
            <div class="container">
                <div class="order-box">
                    <div class="order-img">
                        <img src="https://static.qyjmed.com/webSite/productService/service/service1.png" alt="">
                    </div>
                    <p>订单管理</p>
                </div>
                <div class="order-box">
                    <div class="order-img">
                        <img src="https://static.qyjmed.com/webSite/productService/service/service2.png" alt="">
                    </div>
                    <p>报修管理</p>
                </div>
                <div class="order-box">
                    <div class="order-img">
                        <img src="https://static.qyjmed.com/webSite/productService/service/service3.png" alt="">
                    </div>
                    <p>保内管理</p>
                </div>
                <div class="order-box">
                    <div class="order-img">
                        <img src="https://static.qyjmed.com/webSite/productService/service/service4.png" alt="">
                    </div>
                    <p>合同管理</p>
                </div>
                <div class="order-box">
                    <div class="order-img">
                        <img src="https://static.qyjmed.com/webSite/productService/service/service5.png" alt="">
                    </div>
                    <p>人员管理</p>
                </div>
            </div>
        </div>
        <!-- 客服系统 -->
        <div class="customer">
            <div class="container">
                <h2>客服系统</h2>
                <div class="customer-box">
                    <div class="customer-img">
                        <img src="https://static.qyjmed.com/webSite/productService/service/service-system.png" alt="">
                    </div>
                    <div data-wow-delay="1s" class="wow bounceInRight customer-text">
                        <p>About customer system</p>
                        <p>帮助维保客服人员跟踪维保信息，全部订单备份管理，第一时间录入，可设置维修模板，符合多样化需求管理。同时对维保合同管理，记录每一份合同与设备关系，报价与回款信息，方便业务统计。</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 订单管理 -->
        <div class="order-stem">
            <div class="container">
                <div data-wow-delay="1s" class="wow bounceInLeft stem-text">
                    <h2>订单管理</h2>
                    <p>报修信息录入，系统管理客服订单，根据设备维修时间自动绑定订单合同，方便、准确、快捷</p>
                </div>
                <div class="stem-img">
                    <img src="https://static.qyjmed.com/webSite/productService/service/service-complate.png" alt="">
                </div>
            </div>
        </div>
        <!-- 报修管理 -->
        <div class="repair">
            <div class="container">
                <div class="repair-box">
                    <img width="100%" src="https://static.qyjmed.com/webSite/productService/service/service-stem1.png" alt="">
                    <div class="repair-text">
                        <h2>报修管理</h2>
                        <p>预设维修过程模板操作设置，使操作过程更便捷</p>
                    </div>
                </div>
                <div class="repair-box">
                    <img width="100%" src="https://static.qyjmed.com/webSite/productService/service/service-stem2.png" alt="">
                    <div class="repair-text">
                        <h2>保内管理</h2>
                        <p>保内管理包含医院管理、设备管理、供应商管理，为用户信息提供安全的管理模块</p>
                    </div>
                </div>
                <div class="repair-box">
                    <img width="100%" src="https://static.qyjmed.com/webSite/productService/service/service-stem3.png" alt="">
                    <div class="repair-text">
                        <h2>合同管理</h2>
                        <p>客服录入合同详情，记录合同明细，并绑定开票记录，在每份合同中记录回款信息，客服工作一目了然</p>
                    </div>
                </div>
                <div class="repair-box">
                    <img width="100%" src="https://static.qyjmed.com/webSite/productService/service/service-stem4.png" alt="">
                    <div class="repair-text">
                        <h2>人员管理</h2>
                        <p>管理各种角色人员，包括客服、销售、保内医院人员、保外医院人员、驻场工程师</p>
                    </div>
                </div>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
import {WOW} from 'wowjs';
export default {
  name: 'service',
  mounted() {
      var wow=new WOW({
          live: false
      })
      wow.init()
  },
  components: {
      Foot
  }
}
</script>

<style lang="scss" scoped>
    .service{
        .banner-img{
            margin-top: $highlight-height;
            background: url('https://static.qyjmed.com/webSite/productService/service/service-bg.png') center;
            height: 285px;
        }
        .order{
            .container{
                .order-box{
                    width: 240px;
                    display: inline-block;
                    text-align: center;
                    margin-bottom: 80px;
                    .order-img{
                        margin-top: 30px;
                        &:hover{
                            animation: heartBeat 1s;
                        }
                    }
                    p{
                        font-size: 18px;
                        margin-top: 40px;
                        color: #4C4C4E;
                    }
                }
            }
        }
        // 客服系统
        .customer{
            background: #FAFAFA;
            .container{
                h2{
                    text-align: center;
                    font-size: 30px;
                    padding:52px 0 62px;
                }
                .customer-box{
                    .customer-img{
                        width: 650px;
                        display: inline-block;
                        vertical-align: top;
                        margin-bottom: 100px;
                    }
                }
                .customer-text{
                    width: 550px;
                    display: inline-block;
                    font-size: 22px;
                    line-height: 50px;
                    color: #919192;
                    P{
                        font-size: 16px;
                        line-height: 40px;
                        &:first-child{
                            font-size: 28px;
                            color:#4C4C4E;
                            margin-top: 44px;
                            margin-bottom: 20px;
                        }
                    }
                }
            }
        }
        // 订单管理
        .order-stem{
            background: url('https://static.qyjmed.com/webSite/productService/service/complate.png');
            height: 225px;
            .container{
                .stem-text{
                    width: 600px;
                    display: inline-block;
                    vertical-align: top;
                    color: white;
                    h2{
                        margin:42px 0 28px 72px;
                    }
                    p{
                        width: 500px;
                        margin-left: 72px;
                        line-height: 38px;
                    }
                }
                .stem-img{
                    width: 600px;
                    display: inline-block;
                    img{
                        margin-top: -158px;
                    }
                }
            }
        }
        // 报修管理
        .repair{
            .container{
                .repair-box{
                    width: 260px;
                    margin: 72px 53px 100px 0;
                    display: inline-block;
                    vertical-align: top;
                    .repair-text{
                        text-align: center;
                        box-shadow:-5px 5px 10px -4px #a09bd826,5px 5px 10px -4px #a09bd826;
                        margin-top: -5px;
                        h2{
                            padding:27px 0 16px;
                            font-size: 24px;
                            font-weight: 400;
                        }
                        p{
                            font-size: 14px;
                            line-height: 26px;
                            color: #6A6A6A;
                            padding:0 12px;
                            height: 120px;
                        }
                    }
                    &:last-child{
                        margin-right: 0;
                    }
                }
            }
        }
    }
</style>
